import { createAction, props } from '@ngrx/store';
import { IPersona, ICreatePersona, IDeletePersonaResponse, IUpdatePersona, IUpdatePersonaResponse } from '../../interfaces/personas.interface';

export const GetPersonas = createAction(
    '[Personas] Get Personas',
  );

export const GetPersonasSuccess = createAction(
    '[Personas] Get Personas Success',
    props<{personas: IPersona[]}>()
  );

export const CreatePersona = createAction(
    '[Personas] Create Personas',
    props<{persona: ICreatePersona}>()
  );

export const CreatePersonaSuccess = createAction(
    '[Personas] Create Persona Success',
    props<{persona: IPersona}>()
  );

export const DeletePersona = createAction(
    '[Personas] Delete Persona',
    props<{id: string}>()
  );

export const DeletePersonaSuccess = createAction(
    '[Personas] Delete Persona Success',
    props<{persona: IDeletePersonaResponse}>()
  );

export const UpdatePersona = createAction(
    '[Personas] Update Persona',
    props<{id: string, persona: IUpdatePersona}>()
  );

export const UpdatePersonaSuccess = createAction(
    '[Personas] Update Persona Success',
    props<{persona: IUpdatePersonaResponse}>()
  );
